import { Container } from "@mui/material";
import AvailabilityTicketForm from "../../../components/view/availability/availability-ticket-form.jsx";
import MobileHeader from "../../../components/common/mobile-header/mobile-header.js";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getDomesticFlightPageUrl, getIntFlightPageUrl } from "../../../routing/routingConstants/AppUrls.js";
import { useContext } from "react";
import { LocaleContext } from "../../../routing/LangRouter.js";

function FlightAvailabilityNotification() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { locale } = useContext(LocaleContext);

    const { isFlightInternational } = JSON.parse(sessionStorage.getItem("generalInformation")) || {};

    const previousPage = isFlightInternational ? getIntFlightPageUrl(locale) : getDomesticFlightPageUrl(locale);
    const handleGoBack = () => {
        navigate(previousPage);
    };
    return (
        <Container maxWidth="lg">
            <MobileHeader title={t("confirmInformation")} justifyContent="center" handleClick={handleGoBack} />
            <AvailabilityTicketForm type="notification" />
        </Container>
    );
}
export default FlightAvailabilityNotification;
